import * as React from 'react'
import { castingStoreGetMaxDuration, castingStoreGetMinDuration, StoreProps } from '../../../../services/stores/casting.store'
import { formatDurationFromSecs, utilRange } from '../../../../services/utils/utils.service'
import { Select } from '../../../shared/select.component'
import { I18nService } from '../../../../services/utils/i18n.service'
import { castingExtendsAllowedPatternOnDurationChanged } from '../../../../services/models/castings.service'

type Props = StoreProps & { resultForAllSlots: number }
const i18nScoped = new I18nService(require('./casting-duration-calculator-feedback.component.yml'))

export default function CastingDurationCalculatorFeedbackComponent ({ store, data, data: { offeredService: os, calculatorResult, slots }, resultForAllSlots }: Props) {
  if (os.calculator_hide_duration) return null

  const tooltips = utilRange(resultForAllSlots, castingStoreGetMaxDuration(data) + os.duration_step, os.duration_step)
    .map(value => ({ value, label: formatDurationFromSecs(value) }))

  if (os.calculator_duration_is_recommendation) {
    return <React.Fragment>
      <p className="inputCheckbox-text">
        { i18nScoped.t(calculatorResult === tooltips[0].value ? 'minimum' : 'recommendation') }&nbsp;
        <span style={{ 'fontWeight': 'bold' }}>{ tooltips[0].label }</span>.&nbsp;
        { i18nScoped.t('you_can_change_duration') }
      </p>

      <Select
        options={ tooltips }
        value={ tooltips.find(val => val.value === castingStoreGetMinDuration(data)) }
        onChange={ val => {
          const duration = val.value
          store.set({ calculatorResult: val.value })
          store.setSlots(castingExtendsAllowedPatternOnDurationChanged(slots, duration - slots[0].duration))
        } }
        isSearchable={ false } />
    </React.Fragment>
  }

  return <p className="inputCheckbox-text">
    { i18nScoped.t('exact_duration') } <span style={{ 'fontWeight': 'bold' }}>{ tooltips[0].label }</span>
  </p>
}
